import { LISTING_STATUS } from '../constants/listingStatus';
import { stageListingProductsFromCreateDraft } from '../stageListingProductsFromCreateDraft';
import { syncTreeSelectionToProductLayer } from '../syncTreeSelectionToProductLayer';
import { findListingEntity } from './entityReadHelpers';
import getMasterIdsFromSelectionEntry from './getMasterIdsFromSelectionEntry';

export const resolvePublishedLayerTab = (listing) => {
  if (listing?.live || listing?.listingStatus === LISTING_STATUS.PUBLISHED) {
    return LISTING_STATUS.PUBLISHED;
  }

  return listing?.listingStatus || LISTING_STATUS.DRAFT;
};

export default function syncTreeSelectionAfterPublish({
  dispatch,
  getState,
  productId,
  channelId,
  listing,
} = {}) {
  if (!dispatch || !getState || !productId || !channelId) return;

  const existingListing = findListingEntity(getState().products, {
    masterProductId: productId,
    channelId,
    listingProductId: listing?._id,
  });
  const listingProduct = {
    ...existingListing,
    ...listing,
    masterProductId: productId,
  };

  dispatch(stageListingProductsFromCreateDraft({
    productId,
    listingProducts: [{
      channelId,
      listingProduct,
      fromCreateDraft: false,
    }],
  }));

  const selection = getState().products?.ui?.selection;
  const entry = selection?.byKey?.[selection.keys?.[0]] || null;
  const { variantId } = getMasterIdsFromSelectionEntry(entry);

  dispatch(syncTreeSelectionToProductLayer({
    productId,
    variantId,
    channelId,
    tab: resolvePublishedLayerTab(listingProduct),
  }));
}
